import 'url-search-params-polyfill';
import { useLocation } from 'react-router-dom';
import qs from 'query-string'

// 获取路由参数
export default function useSearch() {
    const location = useLocation();
    return qs.parse(location.search);
}